import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { MORE } from "@/mk/autogenerated/translations/PostMenuTrigger.5bd60c4f2766a265cd80fd1a818e1769";

import styles from "./PostMenuTrigger.mscss";

interface OwnProps {
    className?: string;
    onClick: React.MouseEventHandler<HTMLElement>;
}

type Props = OwnProps;

class PostMenuTrigger extends React.Component<Props> {
    public render() {
        const { className, onClick } = this.props;

        return (
            <div
                className={cx(styles.PostMenuTrigger, className)}
                onClick={onClick}
                role="button"
                aria-label={MORE}
                tabIndex={0}
            >
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
        );
    }
}

export default PostMenuTrigger;
